import { cn } from "@/lib/utils";

interface FormRowProps {
  children: React.ReactNode;
  className?: string;
}

const FormRow = ({ children, className }: FormRowProps) => {
  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-2 gap-4", className)}>
      {children}
    </div>
  );
};

export default FormRow;